import { useMemo } from "react";
import { buildPortalNavigation } from "../config/portalFeatureNav";
import { useAccess } from "../context/AccessContext";
import { clearAuthCaches } from "../utils/authCache";

export function clearPortalFeaturesCache() {
  clearAuthCaches();
}

/**
 * Compatibility hook over AccessContext.
 * Portal features are loaded once via GET /api/user/me.
 */
export default function usePortalFeatures() {
  const { features, loading, reload, isTeamMember } = useAccess();

  const navigation = useMemo(
    () => buildPortalNavigation(features, { isTeamMember }),
    [features, isTeamMember],
  );

  return {
    features,
    navigation,
    loading,
    reload,
    isTeamMember,
  };
}
